import { apiUrl } from "@/api/config";
/**
 * Page-level cache of in-flight/resolved Orion lookups, keyed by dealerId. The Track Price CTA
 * renders for every VIN on SRP/VDP, so this guarantees a single backend call per page regardless
 * of how many CTAs ask for the status. (The VCLWSAA backend additionally caches the CLNTBAA read.)
 */
const orionStatusCache = new Map();
/** Clears the page-level cache. Intended for tests. */
export const resetDealerFeaturesCache = () => {
    orionStatusCache.clear();
};
export class DealerFeaturesService {
    constructor() {
        this.baseUrl = apiUrl("/config/");
    }
    /**
     * Reads the dealer's Orion status from the VCLWSAA dealer-config endpoint (which proxies CLNTBAA).
     * Memoized per dealerId so the toggle is only fetched once per page.
     * Fails closed: returns false on any non-ok response or network error so a backend
     * problem never renders the Orion CTA or breaks the price stack.
     */
    async getIsOrionEnabled(dealerId) {
        const cached = orionStatusCache.get(dealerId);
        if (cached) {
            return cached;
        }
        const request = this.fetchIsOrionEnabled(dealerId);
        orionStatusCache.set(dealerId, request);
        return request;
    }
    async fetchIsOrionEnabled(dealerId) {
        try {
            const response = await fetch(`${this.baseUrl}${dealerId}`);
            if (!response.ok) {
                console.error("error fetching Orion status", response.statusText);
                return false;
            }
            const data = await response.json();
            return data?.isOrionEnabled ?? false;
        }
        catch (error) {
            console.error("error fetching Orion status", error);
            return false;
        }
    }
}
